import { render, staticRenderFns } from "./brandApply.vue?vue&type=template&id=2058c725&scoped=true"
import script from "./brandApply.vue?vue&type=script&lang=js"
export * from "./brandApply.vue?vue&type=script&lang=js"
import style0 from "./brandApply.vue?vue&type=style&index=0&id=2058c725&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2058c725",
  null
  
)

export default component.exports